var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"prt-input"},[_vm._t("default"),_c('input',{class:{'single-char': _vm.singleChar, error: _vm.error},style:({marginLeft: _vm.$slots.default ? '' : '0px'}),attrs:{"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}}),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }